// import instagramIcon from '/img/iconos/instagram.png';
import tiktokIcon from '/img/iconos/tiktok.png';
import githubIcon from '/img/iconos/github.png';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../../components/Translation';

declare global {
  interface Window {
    ml_webform_success_47671595?: () => void;
  }
}

export default function Footer() {
  const { t } = useTranslation();
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    window.ml_webform_success_47671595 = () => setIsSubscribed(true);

    const scriptUrl = 'https://groot.mailerlite.com/js/w/webforms.min.js?v83147fa8ce2d95cb73ece7f28b469519';
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.onerror = () => console.error('Failed to load the MailerLite form script.');
      document.body.appendChild(script);
    }

    void fetch('https://assets.mailerlite.com/jsonp/2746304/forms/202488790891103651/takel')
      .catch((error: unknown) => console.error('Failed to initialize the MailerLite form.', error));

    return () => {
      delete window.ml_webform_success_47671595;
    };
  }, []);

  return (
    <footer className="bg-[#0a1628] text-white">
      <div className="max-w-6xl mx-auto px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* Col 1: Brand */}
        <div className="min-w-0">
          <h3 className="text-lg font-bold mb-2">{t('laboratorio.lab_rob_ind')}</h3>
          <p className="text-white/60 text-mini mb-4">{t('laboratorio.fi_uady')} – UADY</p>
          <address className="not-italic text-white/60 text-mini leading-relaxed">
            Av. Industrias No. 1234, Mérida, Yucatán.<br />
            Tel: (999) 942 3140
          </address>
        </div>

        {/* Col 2: Quick links */}
        <div>
          <h3 className="text-dorado-uady text-mini font-bold uppercase tracking-widest mb-4">
            {t('laboratorio.footer_enlaces')}
          </h3>
          <ul className="space-y-2 text-mini text-white/70">
            <li>
              <a href="https://ingenieria.uady.mx" target="_blank" rel="noopener noreferrer" className="hover:text-dorado-uady transition-colors">
                {t('laboratorio.fi_uady')}
              </a>
            </li>
            <li>
              <a href="https://ingenieria.uady.mx/fing-oferta-educativa/posgrados_maestria" target="_blank" rel="noopener noreferrer" className="hover:text-dorado-uady transition-colors">
                {t('laboratorio.posgrados_maestria')}
              </a>
            </li>
            <li>
              <a href="https://ingenieria.uady.mx/fing-oferta-educativa/posgrados_doctorado" target="_blank" rel="noopener noreferrer" className="hover:text-dorado-uady transition-colors">
                {t('laboratorio.posgrados_doctorado')}
              </a>
            </li>
            <li>
              <a href="https://ingenieria.uady.mx/fing-nuestra-facultad/croquis_edificios" target="_blank" rel="noopener noreferrer" className="hover:text-dorado-uady transition-colors">
                {t('laboratorio.footer_mapa')}
              </a>
            </li>
          </ul>
        </div>

        {/* Col 3: Newsletter / social */}
        <div>
          <h3 className="text-dorado-uady text-mini font-bold uppercase tracking-widest mb-4">
            {t('laboratorio.footer_boletin')}
          </h3>
          <p className="text-white/60 text-mini mb-4">
            {t('laboratorio.footer_suscribete')}
          </p>
          <div id="mlb2-47671595" className="ml-form-embedContainer ml-subscribe-form ml-subscribe-form-47671595">
            {isSubscribed ? (
              <p className="text-mini text-white/80" role="status">
                {t('laboratorio.footer_suscripcion_exitosa')}
              </p>
            ) : (
              <div className="ml-form-embedBody ml-form-embedBodyDefault row-form">
                <form
                  className="ml-block-form flex min-w-0 gap-2"
                  action="https://assets.mailerlite.com/jsonp/2746304/forms/202488790891103651/subscribe"
                  method="post"
                >
                  <input
                    type="email"
                    name="fields[email]"
                    placeholder="email@uady.mx"
                    autoComplete="email"
                    aria-label="Email"
                    aria-required="true"
                    required
                    className="min-w-0 flex-1 bg-white/10 border border-white/20 rounded px-3 py-2 text-mini text-white placeholder-white/40 focus:outline-none focus:border-dorado-uady"
                  />
                  <input type="hidden" name="ml-submit" value="1" />
                  <input type="hidden" name="anticsrf" value="true" />
                  <div className="ml-form-embedSubmit shrink-0">
                    <button
                      type="submit"
                      aria-label={t('laboratorio.footer_suscribirse')}
                      className="primary bg-dorado-uady text-white px-3 py-2 rounded hover:bg-yellow-600 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                    <button disabled type="button" className="loading hidden" aria-hidden="true">
                      <span className="sr-only">Loading...</span>
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
          <div className="flex gap-4 mt-6">
            {/* <a href="https://www.instagram.com/lab_rob_ind_4.0" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-rosa-instagram transition-colors">
              <img src={instagramIcon} alt="Instagram" className="w-4 h-4" />
            </a> */}
            <a href="https://www.tiktok.com/@lab_robotica_industria40" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-cyan-tiktok transition-colors">
              <img src={tiktokIcon} alt="TikTok" className="w-4 h-4" />
            </a>
            <a href="https://github.com/Laboratorio-de-robotica-e-industria-4-0" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-gray-github transition-colors">
              <img src={githubIcon} alt="GitHub" className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 text-center text-micro text-white/40 py-4">
        © {new Date().getFullYear()} {t('laboratorio.lab_rob_ind')} – UADY. {t('laboratorio.footer_derechos')}
      </div>
    </footer>
  );
}